import {CALL_API} from 'middleware/api';
import * as ActionTypes from '../HistoryBet';

export function removeHistoryBet(data) {
    return {type: ActionTypes.REMOVE_HISTORY_BET, data};
}

export function removeHistoryBets(data) {
    return {type: ActionTypes.REMOVE_HISTORY_BETS, data};
}

function fetchBetTypes(data) {
    return {
        type: ActionTypes.REQUEST_BET_TYPES,
        [CALL_API]: {
            endpoint: '/api/bet/basket',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_REQUEST_BET_TYPES,
                ActionTypes.FAILURE_REQUEST_BET_TYPES
            ],
            credentials: true,
            data
        }
    };
}

export function requestBetTypes() {
    return (dispatch, getState) => {
        try {
            const couponBetSlips = getState().application.getIn(['coupon', 'betSlips']);
            if (!couponBetSlips) {
                return null;
            }
    
            let factors = [];
    
            couponBetSlips.forEach(r => {
                const rate = r.get('rate');
                const match = r.get('match');
    
                const basket = {
                    eventId: rate.get('matchId'),
                    eventTimeAndZone: match.get('timeAndZone'),
                    outcomeId: rate.get('outcomeId'),
                    factorId: rate.get('id')
                };
    
                factors.push(basket);
            });
    
            return dispatch(fetchBetTypes(factors));            
        } catch (error) {
            return null;
        }
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/HistoryBet.js